export type TexKind = 'stone' | 'floor' | 'road' | 'block' | 'smoke';
export interface TexLayer { w: number; h: number; ch: 1 | 4; data: Uint8ClampedArray }
export type TexResult = Record<string, TexLayer>;

/** Full texture sizes; workers fill horizontal bands [y0, y1). */
export const TEX_SIZE: Record<TexKind, [number, number]> = { stone: [1024, 1024], floor: [512, 1024], road: [1024, 288], block: [1024, 512], smoke: [256, 256] };
